import { useDispatch, useSelector } from "react-redux"
import React, { useState } from "react"

import { FaCaretDown } from "react-icons/fa"

import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"

const FilterComponenent = ({
  selectedAgeValue,
  setSelectedAgeValue,
  selectedPositionValue,
  setSelectedPositionValue,
  selectedLevelValue,
  setSelectedLevelValue,
  setCurrentPage,
  getAll,
  searchValue,
}) => {
  const dispatch = useDispatch()

  const { currentPage } = useSelector((state) => state.Player)

  const [dropdownOpenAge, setDropdownOpenAge] = useState(false)
  const [dropdownOpenPosition, setDropdownOpenPosition] = useState(false)
  const [dropdownOpenLevel, setDropdownOpenLevel] = useState(false)

  const toggleDropdownAge = () => setDropdownOpenAge(!dropdownOpenAge)
  const toggleDropdownPosition = () =>
    setDropdownOpenPosition(!dropdownOpenPosition)
  const toggleDropdownLevel = () => setDropdownOpenLevel(!dropdownOpenLevel)

  const ageOptions = [
    { label: "Âge-All", value: null },
    { label: "Moins de 18 ans", value: "lessThan18" },
    { label: "18-25 ans", value: "between18And25" },
    { label: "Plus de 25 ans", value: "moreThan25" },
  ]

  const positionOptions = [
    { label: "Position-All", value: null },
    { label: "Gardien de buts", value: "Goalkeeper" },
    { label: "Défenseur", value: "Defender" },
    { label: "Milieu de terrain", value: "Midfielder" },
    { label: "Attaquant", value: "Forward" },
  ]

  const levelOptions = [
    { label: "Niveau de jeux-All", value: null },
    { label: "Amateur", value: "Amateur" },
    { label: "Semi-professionnel", value: "semi-pro" },
    { label: "Professionnel", value: "Professional" },
  ]

  const handleAgeSelect = (value) => {
    if (value !== selectedAgeValue) {
      setSelectedAgeValue(value)
      if (currentPage === 1) {
        dispatch(
          getAll({
            page: 1,
            age: value,
            position: selectedPositionValue,
            level: selectedLevelValue,
            searchValue: searchValue,
          })
        )
      } else {
        dispatch(setCurrentPage(1))
      }
    }
  }

  const handlePositionSelect = (value) => {
    if (value !== selectedPositionValue) {
      setSelectedPositionValue(value)
      if (currentPage === 1) {
        dispatch(
          getAll({
            page: 1,
            age: selectedAgeValue,
            position: value,
            level: selectedLevelValue,
            searchValue: searchValue,
          })
        )
      } else {
        dispatch(setCurrentPage(1))
      }
    }
  }

  const handleLevelSelect = (value) => {
    if (value !== selectedLevelValue) {
      setSelectedLevelValue(value)
      if (currentPage === 1) {
        dispatch(
          getAll({
            page: 1,
            age: selectedAgeValue,
            position: selectedPositionValue,
            level: value,
            searchValue: searchValue,
          })
        )
      } else {
        dispatch(setCurrentPage(1))
      }
    }
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "15px",
          alignItems: "center",
          marginTop: 15,
        }}
      >
        {/* Dropdown for Age */}
        <Dropdown isOpen={dropdownOpenAge} toggle={toggleDropdownAge}>
          <DropdownToggle
            tag="span"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ccc",
              padding: "5px 10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {
              // Trouve le label correspondant à la valeur sélectionnée
              ageOptions.find((option) => option.value === selectedAgeValue)
                ?.label ?? "Âge-All"
            }
            <FaCaretDown style={{ marginLeft: "5px" }} />
          </DropdownToggle>
          <DropdownMenu>
            {ageOptions.map((option) => (
              <DropdownItem
                key={option.value ?? "default"}
                onClick={() => handleAgeSelect(option.value)}
              >
                {option.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>

        {/* Dropdown for Position */}
        <Dropdown isOpen={dropdownOpenPosition} toggle={toggleDropdownPosition}>
          <DropdownToggle
            tag="span"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ccc",
              padding: "5px 10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {positionOptions.find(
              (option) => option.value === selectedPositionValue
            )?.label ?? "Position-All"}
            <FaCaretDown style={{ marginLeft: "5px" }} />
          </DropdownToggle>
          <DropdownMenu>
            {positionOptions.map((option) => (
              <DropdownItem
                key={option.value ?? "default"}
                onClick={() => handlePositionSelect(option.value)}
              >
                {option.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>

        {/* Dropdown for Level */}
        <Dropdown isOpen={dropdownOpenLevel} toggle={toggleDropdownLevel}>
          <DropdownToggle
            tag="span"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ccc",
              padding: "5px 10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {levelOptions.find((option) => option.value === selectedLevelValue)
              ?.label ?? "Niveau de jeux-All"}
            <FaCaretDown style={{ marginLeft: "5px" }} />
          </DropdownToggle>
          <DropdownMenu>
            {levelOptions.map((option) => (
              <DropdownItem
                key={option.value ?? "default"}
                onClick={() => handleLevelSelect(option.value)}
              >
                {option.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  )
}

export default FilterComponenent
